import { useI18n } from '../i18n';
import { STATS } from '../constants';
import { Reveal } from './Reveal';

/** Achievements band: gold, shimmering figures over the starfield. */
export const Stats = () => {
  const { t } = useI18n();
  return (
    <section className="stats">
      <div className="wrap">
        <div className="grid">
          {STATS.map((s, i) => (
            <Reveal key={s.key} className="stat" delay={i}>
              <div className="num">{s.value}</div>
              <div className="lbl">{t.stats[s.key]}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
